import React from 'react'
import { capitalizeFirstLetter } from '../utils/functions'
import ImageWithBasePath from './ImageWithBasePath'
import classNames from 'classnames'
import { NextLink } from '../commonComponents/NextLink'

export const LocationShow = ({ isHomePage, isMenuClicked, location, locationHandler }) => {
  return (
    <NextLink
      id={'location_selection'}
      href="locationSelectionPage"
      as="jobs/jobs-near-me"
      isLoader={false}
    >
      <div
        id="header_location_container"
        className={classNames(
          'flex h-[24px] cursor-pointer items-center border-[0px] active:bg-grey active:bg-opacity-5',
          !isMenuClicked && 'border-[0px] border-r-xs border-solid border-r-[#E5E5E6]'
        )}
        onClick={locationHandler}
      >
        {!isMenuClicked && (
          <div
            id="header_location_title"
            className="flex max-w-max items-center space-x-[4px] pr-[10px]"
          >
            <div className="max-h-[19.07px] max-w-[100px] select-none truncate font-noto-sans text-base font-normal leading-[19.07px] text-[#17191C] sm:max-h-full sm:max-w-full sm:text-md sm:leading-[24px]">
              {location
                ? capitalizeFirstLetter(location?.title || location?.name)
                : 'Select location' || 'Select Location'}
            </div>
            <div id="header_down_arrow" className="flex h-fit w-fit items-center">
              <ImageWithBasePath
                src="locationsDownArrow"
                width={24}
                height={24}
                alt="down arrow symbol"
              />
            </div>
          </div>
        )}
      </div>
    </NextLink>
  )
}